import _omit from "lodash/omit";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { HazardousMaterial } from 'swag-common/interfaces';
const SIZE_STANDARD_INDEX = 0;
const VARIANT_STANDARD_INDEX = 0;
const PRODUCTION_TIME_STANDARD_INDEX = 0;
const FULL_DESIGN_DEFAULT_VARIANT_INDEX = 0;
export const BACK_IN_STOCK_VALID_DATE_FORMAT = 'MM/DD/YYYY';
const FRONT = 'front';
const BACK = 'back';
const LEFT = 'left';
const RIGHT = 'right';
const BRANDED = 'branded';
const PRINT_SIDE = {
  [FRONT]: FRONT,
  [BACK]: BACK,
  [LEFT]: LEFT,
  [RIGHT]: RIGHT
};
const BASIC_BOX = 'basicBox';
const DEFAULT_TAX_CODE = 'PP198874';
const MAX_QUANTITY_TO_BUY = 100000;
const PRODUCTION_TIME_STANDART_TEXT = 'Standard';
const PRODUCTION_TIME_PRIORITY_TEXT = 'Priority';
const PRODUCTION_TIME_VIP_TEXT = 'VIP';
export const PRODUCTION_TIME_SAMPLE_VALUE = 0;
export const PRODUCTION_TIME_SAMPLE_DAYS = 1;
export const PRODUCTION_TIME_SAMPLE_TEXT = 'Sample';
export const SAMPLE_PRODUCTION_TIME_OBJECT = {
  name: PRODUCTION_TIME_SAMPLE_TEXT,
  cost: PRODUCTION_TIME_SAMPLE_VALUE,
  time: PRODUCTION_TIME_SAMPLE_DAYS
};
export const MAX_PRINT_COLORS_LIMIT = 20;
const MAX_CUSTOM_BOX_PRODUCTS = 7;
const PRODUCT_VISIBILITY = {
  HIDDEN: 'hidden',
  REGULAR: 'regular',
  SEARCHABLE_ONLY: 'searchableOnly',
  LINK_ONLY: 'linkOnly',
  LIMITED_EDITION: 'limitedEdition.isLimitedEdition',
  FORBIDDEN_FOR_BOX: 'forbiddenForBox',
  IS_SUGGESTED: 'isSuggested',
  SPECIAL_PRODUCTS: 'specialProductType',
  IS_BASIC_BOX: 'isBasicBox',
  // @todo
  HAS_DONATE_WIDGET: 'hasDonateWidget',
  IS_ALWAYS_IN_STOCK: 'isAlwaysInStock',
  FORBIDDEN_FOR_INVENTORY: 'forbiddenForInventory',
  IS_BREAKABLE_PRODUCTS: 'isBreakable',
  SUPER_SPEED: 'superSpeed',
  CORE: 'core',
  IS_CUSTOM_INK_OFS_FLOW_ENABLED: 'isCustomInkOFSFlowEnabled',
  IS_EXPIRABLE_PRODUCT: 'isExpirableProduct',
  FORBIDDEN_TO_SHIP_INTERNATIONALLY: 'isForbiddenToShipInternationally'
};
export const NOT_CORE_PRODUCTS = [PRODUCT_VISIBILITY.HIDDEN, PRODUCT_VISIBILITY.LINK_ONLY, PRODUCT_VISIBILITY.SEARCHABLE_ONLY];
const PRODUCT_SORTING = {
  HIGHEST_PRICE: 'highestPrice',
  LOWEST_PRICE: 'lowestPrice',
  LATEST: 'latest',
  NEWEST: 'newest',
  MOST_POPULAR: 'mostPopular',
  CUSTOM: 'custom',
  RELEVANCE: 'relevance',
  HOTTEST: 'hottest'
};
export const CSV_COLUMNS = {
  NAME: 'Product name',
  NUM: 'Num',
  TAX_CODE: 'Tax code',
  MIN_QUANT: 'Minimum Quantity',
  QUANT_INCREMENT: 'Quantity increment',
  POPULARITY: 'Popularity',
  DESCRIPTION_FOR_WAREHOUSE: 'Description for Warehouse',
  DESCRIPTION: 'Description',
  SEO_TITLE: 'SEO title',
  SEO_DESCRIPTION: 'SEO description',
  PRINTING_PROCESS_DESCRIPTION: 'Printing process description',
  BOX_LENGTH: 'Box length',
  BOX_WIDTH: 'Box width',
  BOX_HEIGHT: 'Box height',
  BOX_WEIGHT: 'Box weight',
  ITEM_WEIGHT: 'One item weight',
  ITEMS_IN_BOX: 'Items in a box',
  MARGIN: 'Margin',
  SCREEN_PRICE: 'Screen price',
  MAX_PRINT_COLORS: 'Max print colors',
  DISTRIBUTION_FEE: 'Distribution fee',
  SAMPLE_PRICE: 'Blank sample price',
  PRINTED_SAMPLE_PRICE: 'Printed sample price',
  PRODUCT_LABEL: 'Product label',
  SIZE_DEPENDENT_PRICE: 'Size-dependent price',
  EMBROIDERY_PRODUCT: 'Embroidery product',
  VARIANT_DEPENDENT_PRICE: 'Variant-dependent price',
  ADD_ONE_COLOR: 'Add one color',
  SWAG_LOGO_DISCOUNT: '10% discount option (printed swag.com logo)',
  _ID: 'Product ID (not editable)',
  CATEGORIES: 'Categories IDs (not editable)',
  SUPPLIER: 'Vendor ID (not editable)',
  HIDDEN: 'Hidden',
  OUT_OF_STOCK: 'Out of stock',
  BACK_IN_STOCK: `Back in stock (${BACK_IN_STOCK_VALID_DATE_FORMAT})`,
  IS_SUGGESTED: 'Is suggested',
  FORBIDDEN_FOR_BOX: 'Forbidden for box',
  FORBIDDEN_FOR_INVENTORY: 'Forbidden for inventory',
  HAZARDOUS_MATERIAL: `Hazardous materials (${Object.values(HazardousMaterial).join('/')})`,
  LINK_ONLY: 'Link only',
  SEARCHABLE_ONLY: 'Searchable only',
  CREATED_AT: 'Created At (not editable)',
  IS_BREAKABLE: 'Breakable',
  IS_EXPIRABLE_PRODUCT: 'Expiring Good',
  IS_FORBIDDEN_TO_SHIP_INTERNATIONALLY: 'Forbidden To Ship Internationally'
};
const CSV_ATTRIBUTES_COLUMNS = {
  NAME: 'Product name (not editable)',
  _ID: 'Product ID (not editable)'
};
const FIELD_TYPES = {
  ARRAY: ['tenantVisibility', 'priceTags'],
  STRING: ['name', 'num', 'taxCode', 'descr', 'seoTitle', 'seoDescription', 'printingProcessDescription', 'productLabel', 'hazardousMaterial', 'assignedToAssociate'],
  NUMBER: ['boxLength', 'boxWidth', 'boxHeight', 'boxWeight', 'itemWeight', 'itemsInBox', 'margin', 'minQuant', 'quantIncrement', 'maxPrintColors', 'spaceMargin'],
  PRICE: ['distributionFee', 'samplePrice', 'printedSamplePrice'],
  BOOLEAN: ['sizeDependentPrice', 'variantDependentPrice', 'swagLogoDiscount', 'hidden', 'linkOnly', 'searchableOnly', 'isSuggested', 'forbiddenForBox', 'forbiddenForInventory', 'isBreakable', 'isExpirableProduct', 'isForbiddenToShipInternationally', 'isCustomInkOFSFlowEnabled'],
  SKIP: ['categories', 'supplier', 'createdAt'],
  SORTING: ['popularity']
};
const PRODUCTS_ORDERED_FIELDS = ['name', 'num', 'taxCode', 'minQuant', 'quantIncrement', 'popularity', 'descriptionForWarehouse', 'description', 'seoTitle', 'seoDescription', 'printingProcessDescription', 'boxLength', 'boxWidth', 'boxHeight', 'boxWeight', 'itemWeight', 'itemsInBox', 'isCustomInkOFSFlowEnabled', 'margin', 'spaceMargin', 'resellerMarginReduction', 'tenantVisibility', 'priceTags', 'maxPrintColors', 'distributionFee', 'samplePrice', 'printedSamplePrice', 'productLabel', 'hidden', 'linkOnly', 'searchableOnly', 'isSuggested', 'isBreakable', 'isExpirableProduct', 'isForbiddenToShipInternationally', 'forbiddenForBox', 'forbiddenForInventory', 'hazardousMaterial', 'sizeDependentPrice', 'variantDependentPrice', 'swagLogoDiscount', 'assignedToAssociate', 'createdAt', 'categories', 'supplier', '_id'];
const APPAREL_SIZE_NAMES = {
  XS: 'Extra Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large'
};
export const DESCRIPTION_FOR_WAREHOUSE_CHARACTERS_LIMIT = 20;
const CSV_COLUMNS_PRODUCT = {
  name: 'Product name',
  num: 'Num',
  taxCode: 'Tax code',
  minQuant: 'Minimum Quantity',
  quantIncrement: 'Quantity increment',
  popularity: 'Popularity',
  descriptionForWarehouse: 'Description for Warehouse',
  description: 'Description',
  seoTitle: 'SEO title',
  seoDescription: 'SEO description',
  printingProcessDescription: 'Printing process description',
  // start add shipping setting
  boxLength: 'Box length',
  boxWidth: 'Box width',
  boxHeight: 'Box height',
  boxWeight: 'Box weight',
  itemWeight: 'One item weight',
  itemsInBox: 'Items in a box',
  isCustomInkOFSFlowEnabled: 'Custom Ink OFS flow',
  // end add shipping setting
  margin: 'Margin',
  spaceMargin: 'Swag Space margin',
  resellerMarginReduction: 'Reseller commission (value from 0 to 29 or empty cell)',
  tenantVisibility: 'Tenant visibility',
  priceTags: 'Reseller price tags',
  maxPrintColors: 'Max print colors',
  distributionFee: 'Distribution fee',
  samplePrice: 'Blank sample price',
  printedSamplePrice: 'Printed sample price',
  productLabel: 'Product label',
  isSuggested: 'Is suggested',
  linkOnly: 'Link only',
  searchableOnly: 'Searchable only',
  forbiddenForBox: 'Forbidden for box',
  forbiddenForInventory: 'Forbidden for inventory',
  hazardousMaterial: `${CSV_COLUMNS.HAZARDOUS_MATERIAL}`,
  hidden: 'Hidden',
  // start pricing options
  sizeDependentPrice: 'Size-dependent price',
  embroideryProduct: 'Embroidery product',
  variantDependentPrice: 'Variant-dependent price',
  swagLogoDiscount: '10% discount option (printed swag.com logo)',
  assignedToAssociate: 'Product associate',
  // end pricing options
  createdAt: 'Created At (not editable)',
  _id: 'Product ID (not editable)',
  categories: 'Categories IDs (not editable)',
  supplier: 'Vendor ID (not editable)',
  isBreakable: 'Breakable',
  isExpirableProduct: 'Expiring Good',
  isForbiddenToShipInternationally: 'Forbidden to ship internationally'
};
const PRODUCTS_HEAD = _objectSpread({}, _omit(CSV_COLUMNS_PRODUCT, 'embroideryProduct'));
const MAP_HEADER_TO_FIELDS = Object.fromEntries(Object.entries(_objectSpread({}, PRODUCTS_HEAD, {
  descr: 'Description'
})).map(item => item.reverse()));
export const SUPER_SPEED_PRODUCTION_OPTION = 'Super Speed';
const PRODUCTION_TIME_NAMES_MAP = {
  expedited: 'Expedited',
  priority: 'Priority',
  standard: 'Standard',
  overseas: 'Overseas',
  rush: 'Rush',
  vip: 'VIP',
  sample: 'Sample',
  'next day': 'Next day',
  'super speed': SUPER_SPEED_PRODUCTION_OPTION
};
const PRODUCTION_TIME_NAMES = Object.values(PRODUCTION_TIME_NAMES_MAP);
const PRODUCT_ATTRIBUTES_HEAD = {
  _id: 'Product ID (not editable)',
  name: 'Product name (not editable)'
};
const PRODUCT_ATTRIBUTES_ORDERED_FIELDS = ['_id', 'name'];
const PRODUCT_SETTINGS_HEAD = {
  _id: 'Product ID (not editable)',
  name: 'Product name (not editable)',
  num: 'Product num (not editable)',
  categories: 'Categories IDs (not editable)',
  supplier: 'Vendor ID (not editable)',
  tenantVisibility: 'Tenant visibility (not editable)',
  hidden: 'Hidden (not editable)',
  linkOnly: 'Link only (not editable)',
  searchableOnly: 'Searchable only (not editable)',
  embellishment: 'Embellishment method',
  productionTimeList: 'Production time (Format: NAME-COST INCREASE (%)-TIME (DAYS)/NAME-COST INCREASE (%)-TIME (DAYS))',
  superSpeed: 'MinQuant; MaxQuant; MaxPrintColors (only for Super Speed)'
};
const PRODUCT_SETTINGS_HEAD_PRICE_OPTIONS = {
  screenPrice: 'Screen price',
  colorIndependentPrice: 'Embroidery product',
  colorIndependentScreenPrice: 'Digital print product',
  addOneColor: 'Add one color'
};
const PRODUCT_SETTINGS_HEAD_QUANTITIES_LOCATION_OPTIONS = {
  minQuant: 'Minimum Quantity',
  quantIncrement: 'Quantity increment',
  printingProcessDescription: 'Printing process description',
  maxPrintColors: 'Max print colors',
  printedSamplePrice: 'Printed sample price'
};
const PRODUCT_SETTINGS_HEAD_WITH_PRICE = _objectSpread({}, PRODUCT_SETTINGS_HEAD, PRODUCT_SETTINGS_HEAD_PRICE_OPTIONS);
const PRODUCT_SETTINGS_HEAD_WITH_PRICE_QUANTITIES_LOCATION = _objectSpread({}, PRODUCT_SETTINGS_HEAD, PRODUCT_SETTINGS_HEAD_PRICE_OPTIONS, PRODUCT_SETTINGS_HEAD_QUANTITIES_LOCATION_OPTIONS);
const PRODUCT_SETTINGS_ORDERED_FIELDS = ['name', 'num', '_id', 'categories', 'supplier', 'tenantVisibility', 'hidden', 'linkOnly', 'searchableOnly', 'embellishment', 'productionTimeList', 'superSpeed'];
const PRODUCT_SETTINGS_ORDERED_FIELDS_PRICE_OPTIONS = ['screenPrice', 'colorIndependentPrice', 'colorIndependentScreenPrice', 'addOneColor'];
const PRODUCT_SETTINGS_ORDERED_FIELDS_QUANTITIES_LOCATION_OPTIONS = ['minQuant', 'quantIncrement', 'printingProcessDescription', 'maxPrintColors', 'printedSamplePrice'];
const PRODUCT_SETTINGS_ORDERED_FIELDS_WITH_PRICE = [...PRODUCT_SETTINGS_ORDERED_FIELDS, ...PRODUCT_SETTINGS_ORDERED_FIELDS_PRICE_OPTIONS];
const PRODUCT_SETTINGS_ORDERED_FIELDS_WITH_PRICE_QUANTITIES_LOCATION_OPTIONS = [...PRODUCT_SETTINGS_ORDERED_FIELDS, ...PRODUCT_SETTINGS_ORDERED_FIELDS_PRICE_OPTIONS, ...PRODUCT_SETTINGS_ORDERED_FIELDS_QUANTITIES_LOCATION_OPTIONS];
const PRODUCT_LABELS = {
  NEW: 'new',
  HOT: 'hot',
  NONE: null
};
export let LOGO_UPLOAD_BLANK_OPTIONS = /*#__PURE__*/function (LOGO_UPLOAD_BLANK_OPTIONS) {
  LOGO_UPLOAD_BLANK_OPTIONS["ONLY_PRINTED"] = "ONLY_PRINTED";
  LOGO_UPLOAD_BLANK_OPTIONS["ONLY_BLANK"] = "ONLY_BLANK";
  LOGO_UPLOAD_BLANK_OPTIONS["BLANK_AND_PRINTED"] = "BLANK_AND_PRINTED";
  return LOGO_UPLOAD_BLANK_OPTIONS;
}({});
export let SPECIAL_PRODUCT_TYPES = /*#__PURE__*/function (SPECIAL_PRODUCT_TYPES) {
  SPECIAL_PRODUCT_TYPES["BOX_NOTECARD"] = "BOX_NOTECARD";
  SPECIAL_PRODUCT_TYPES["BOX_TAPE"] = "BOX_TAPE";
  SPECIAL_PRODUCT_TYPES["BOX_CRINKLE_PAPER"] = "BOX_CRINKLE_PAPER";
  SPECIAL_PRODUCT_TYPES["SAMPLE_BOX"] = "SAMPLE_BOX";
  SPECIAL_PRODUCT_TYPES["CUSTOM_BOX"] = "CUSTOM_BOX";
  SPECIAL_PRODUCT_TYPES["BROWN_BOX"] = "BROWN_BOX";
  SPECIAL_PRODUCT_TYPES["COLORED_BOX"] = "COLORED_BOX";
  SPECIAL_PRODUCT_TYPES["FULLY_CUSTOM_BOX"] = "FULLY_CUSTOM_BOX";
  SPECIAL_PRODUCT_TYPES["ADD_ON_FOR_BOX"] = "ADD_ON_FOR_BOX";
  SPECIAL_PRODUCT_TYPES["GIFT_GIVEAWAY_NOTECARD"] = "GIFT_GIVEAWAY_NOTECARD";
  SPECIAL_PRODUCT_TYPES["NO_BOX"] = "NO_BOX";
  return SPECIAL_PRODUCT_TYPES;
}({});
export const CRINKLE_PAPER_ALLOWED_VARIANTS = new Set(['Ivory', 'Light Blue', 'Navy Blue', 'Royal Blue', 'Orange', 'Black', 'Purple', 'Red', 'Gray', 'Green']);
export const SPECIAL_PRODUCT_TYPES_ARR = [SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, SPECIAL_PRODUCT_TYPES.BOX_TAPE, SPECIAL_PRODUCT_TYPES.BOX_CRINKLE_PAPER, SPECIAL_PRODUCT_TYPES.SAMPLE_BOX, SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.BROWN_BOX, SPECIAL_PRODUCT_TYPES.COLORED_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.ADD_ON_FOR_BOX, SPECIAL_PRODUCT_TYPES.GIFT_GIVEAWAY_NOTECARD, SPECIAL_PRODUCT_TYPES.NO_BOX];
export const BOX_TYPE_FOR_SELECTION = [SPECIAL_PRODUCT_TYPES.BROWN_BOX, SPECIAL_PRODUCT_TYPES.COLORED_BOX, SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.NO_BOX];
export const CUSTOM_BOXES = [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX, SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX];
export const SPECIAL_PRODUCT_BUNDLE_ADDON_TYPES = [SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, SPECIAL_PRODUCT_TYPES.BOX_TAPE, ...BOX_TYPE_FOR_SELECTION];
export let PRODUCT_PRICE_TAGS = /*#__PURE__*/function (PRODUCT_PRICE_TAGS) {
  PRODUCT_PRICE_TAGS["SUPER_INEXPENSIVE"] = "SUPER_INEXPENSIVE";
  PRODUCT_PRICE_TAGS["BUDGET"] = "BUDGET";
  PRODUCT_PRICE_TAGS["STANDARD"] = "STANDARD";
  PRODUCT_PRICE_TAGS["PREMIUM"] = "PREMIUM";
  return PRODUCT_PRICE_TAGS;
}({});
export const PRODUCT_PRICE_TAGS_MAP = {
  isSuperInexpensive: PRODUCT_PRICE_TAGS.SUPER_INEXPENSIVE,
  isBudget: PRODUCT_PRICE_TAGS.BUDGET,
  isStandard: PRODUCT_PRICE_TAGS.STANDARD,
  isPremium: PRODUCT_PRICE_TAGS.PREMIUM
};
export const PRODUCT_PRICE_TAGS_OPTIONS = [{
  label: 'Super inexpensive',
  value: PRODUCT_PRICE_TAGS.SUPER_INEXPENSIVE
}, {
  label: 'Budget',
  value: PRODUCT_PRICE_TAGS.BUDGET
}, {
  label: 'Standard',
  value: PRODUCT_PRICE_TAGS.STANDARD
}, {
  label: 'Premium',
  value: PRODUCT_PRICE_TAGS.PREMIUM
}];
export const PRODUCT_PRICE_TAGS_OPTIONS_MAP = PRODUCT_PRICE_TAGS_OPTIONS.reduce((acc, {
  label,
  value
}) => {
  acc[value] = label;
  return acc;
}, {});
export const ADDITIONAL_PRODUCT_TIME_TEXT = 'After artwork approval';
const LOGO_UPLOAD_BLANK_OPTIONS_VALUES = [{
  label: 'Only printed',
  value: LOGO_UPLOAD_BLANK_OPTIONS.ONLY_PRINTED
}, {
  label: 'Blank and printed',
  value: LOGO_UPLOAD_BLANK_OPTIONS.BLANK_AND_PRINTED
}, {
  label: 'Only blank',
  value: LOGO_UPLOAD_BLANK_OPTIONS.ONLY_BLANK
}];
const LOGO_UPLOAD_BLANK_OPTIONS_LABELS_BY_VALUE = LOGO_UPLOAD_BLANK_OPTIONS_VALUES.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});
export { APPAREL_SIZE_NAMES, BACK, BASIC_BOX, BRANDED, CSV_ATTRIBUTES_COLUMNS, CSV_COLUMNS_PRODUCT, DEFAULT_TAX_CODE, FIELD_TYPES, FRONT, FULL_DESIGN_DEFAULT_VARIANT_INDEX, LEFT, LOGO_UPLOAD_BLANK_OPTIONS_LABELS_BY_VALUE, LOGO_UPLOAD_BLANK_OPTIONS_VALUES, MAP_HEADER_TO_FIELDS, MAX_CUSTOM_BOX_PRODUCTS, MAX_QUANTITY_TO_BUY, PRINT_SIDE, PRODUCTION_TIME_NAMES, PRODUCTION_TIME_NAMES_MAP, PRODUCTION_TIME_PRIORITY_TEXT, PRODUCTION_TIME_STANDARD_INDEX, PRODUCTION_TIME_STANDART_TEXT, PRODUCTION_TIME_VIP_TEXT, PRODUCTS_HEAD, PRODUCTS_ORDERED_FIELDS, PRODUCT_ATTRIBUTES_HEAD, PRODUCT_ATTRIBUTES_ORDERED_FIELDS, PRODUCT_LABELS, PRODUCT_SORTING, PRODUCT_VISIBILITY, RIGHT, SIZE_STANDARD_INDEX, VARIANT_STANDARD_INDEX, PRODUCT_SETTINGS_HEAD, PRODUCT_SETTINGS_ORDERED_FIELDS, PRODUCT_SETTINGS_HEAD_WITH_PRICE, PRODUCT_SETTINGS_HEAD_WITH_PRICE_QUANTITIES_LOCATION, PRODUCT_SETTINGS_ORDERED_FIELDS_WITH_PRICE, PRODUCT_SETTINGS_HEAD_QUANTITIES_LOCATION_OPTIONS, PRODUCT_SETTINGS_HEAD_PRICE_OPTIONS, PRODUCT_SETTINGS_ORDERED_FIELDS_PRICE_OPTIONS, PRODUCT_SETTINGS_ORDERED_FIELDS_QUANTITIES_LOCATION_OPTIONS, PRODUCT_SETTINGS_ORDERED_FIELDS_WITH_PRICE_QUANTITIES_LOCATION_OPTIONS };
export let responseText = /*#__PURE__*/function (responseText) {
  responseText["SUCCESS"] = "Thanks! We will send you an email when they are back in stock.";
  responseText["LIMITED_EDITION_SUCCESS"] = "Thanks! We will send you an email when we release new limited edition products.";
  responseText["REMOVED"] = "Email subscription was successfully removed.";
  responseText["ERROR"] = "Oops, something went wrong!";
  return responseText;
}({});
export const BOX_TYPES_LABELS = {
  [SPECIAL_PRODUCT_TYPES.COLORED_BOX]: 'Colored box (unbranded)',
  [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX]: 'Custom  box',
  [SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX]: 'Fully Custom box',
  [SPECIAL_PRODUCT_TYPES.BROWN_BOX]: 'Brown box with logo tape'
};
export const InReservePopupTypes = {
  IN_STOCK: 'inStock',
  IN_PRODUCTION: 'inProduction',
  ALL: 'all',
  IN_STOCK_AVAILABLE: 'inStockAvailable',
  IN_PRODUCTION_AVAILABLE: 'inProductionAvailable'
};
export const PRODUCT_PROPERTIES = {
  apparelSize: 'Apparel Size',
  quantity: 'Quantity',
  color: 'Color',
  size: 'Size'
};
export const LIMITED_EDITION = 'Limited Edition!';
export const STRINGIFIED_FIELDS = ['categories', 'variants', 'price', 'quantities', 'printRunQuantities', 'imagesForSpec', 'tags', 'imagesWithoutImprintArea', 'sortingParams', 'tenantVisibility', 'supplierInventoryLevels', 'attributeValueIds', 'tagsSrc', 'additionalPrintLocations', 'products', 'limitedEdition', 'priceTags'];
export const MAX_PRODUCT_INPUT_NAME_LENGTH = 100;
export const MIN_PRODUCT_INPUT_NAME_LENGTH = 1;
export const MAX_PRODUCT_TEXTAREA_INPUT_LENGTH = 1000;
export const MIN_PRODUCT_TEXTAREA_INPUT_LENGTH = 1;
export const PROD_TIME = {
  LESS_THAN_5_DAYS: '0,5'
};
export const EMBELLISHMENT_METHODS = {
  DEBOSSED: 'debossed',
  LASER_ENGRAVE: 'laser engrave',
  EMBROIDERY: 'embroidery'
};
export const MAX_IMAGES_NAME_LENGTH = 25;
export const MAX_PRODUCT_PRINT_COLORS = 25;
export const NA = 'N/A';
export const INVALID = 'invalid';
export let PRODUCT_STATUS = /*#__PURE__*/function (PRODUCT_STATUS) {
  PRODUCT_STATUS["IMPORTED"] = "imported";
  PRODUCT_STATUS["CREATED"] = "created";
  PRODUCT_STATUS["IN_PROGRESS"] = "in progress";
  PRODUCT_STATUS["ON_REVIEW"] = "on review";
  PRODUCT_STATUS["CHANGES_REQUESTED"] = "changes requested";
  PRODUCT_STATUS["COMPLETED"] = "completed";
  return PRODUCT_STATUS;
}({});
export let PRODUCT_STATUS_OPTIONS_TYPE = /*#__PURE__*/function (PRODUCT_STATUS_OPTIONS_TYPE) {
  PRODUCT_STATUS_OPTIONS_TYPE["ALL"] = "all";
  PRODUCT_STATUS_OPTIONS_TYPE["EDITOR"] = "editor";
  return PRODUCT_STATUS_OPTIONS_TYPE;
}({});
export const PRODUCT_STATUS_LABELS = {
  [PRODUCT_STATUS.IMPORTED]: 'Imported',
  [PRODUCT_STATUS.CREATED]: 'Created',
  [PRODUCT_STATUS.IN_PROGRESS]: 'In progress',
  [PRODUCT_STATUS.ON_REVIEW]: 'On review',
  [PRODUCT_STATUS.CHANGES_REQUESTED]: 'Changes requested',
  [PRODUCT_STATUS.COMPLETED]: 'Completed'
};
export let ALLOWED_PRODUCT_FIELDS_TO_SYNC = /*#__PURE__*/function (ALLOWED_PRODUCT_FIELDS_TO_SYNC) {
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["_id"] = "_id";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["blankProductSupplier"] = "blankProductSupplier";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["logo"] = "logo";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["logoBranded"] = "logoBranded";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["name"] = "name";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["categories"] = "categories";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["quantities"] = "quantities";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["price"] = "price";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["categoryPrice"] = "categoryPrice";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["variants"] = "variants";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["designUploadMode"] = "designUploadMode";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["seoSlug"] = "seoSlug";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["hidden"] = "hidden";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["productLabel"] = "productLabel";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["forbiddenForInventory"] = "forbiddenForInventory";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["forbiddenForBox"] = "forbiddenForBox";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["descriptionForWarehouse"] = "descriptionForWarehouse";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["tenantVisibility"] = "tenantVisibility";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["limitedEdition"] = "limitedEdition";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["spaceMargin"] = "spaceMargin";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["margin"] = "margin";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["hasSize"] = "hasSize";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["isAlwaysInStock"] = "isAlwaysInStock";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["outOfStockThreshold"] = "outOfStockThreshold";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["tags"] = "tags";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["createdAt"] = "createdAt";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["logoUploadBlankOption"] = "logoUploadBlankOption";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["isForbiddenToShipInternationally"] = "isForbiddenToShipInternationally";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["publicId"] = "publicId";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["num"] = "num";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["resellerMarginReduction"] = "resellerMarginReduction";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["specialProductType"] = "specialProductType";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["priceTags"] = "priceTags";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["type"] = "type";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["basePrice"] = "basePrice";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["searchableOnly"] = "searchableOnly";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["linkOnly"] = "linkOnly";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["attributeValueIds"] = "attributeValueIds";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["supplier"] = "supplier";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["popularityIndex"] = "popularityIndex";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["accumulatorIds"] = "accumulatorIds";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["sortingParams"] = "sortingParams";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["childProductIds"] = "childProductIds";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["image"] = "image";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["link"] = "link";
  ALLOWED_PRODUCT_FIELDS_TO_SYNC["title"] = "title";
  return ALLOWED_PRODUCT_FIELDS_TO_SYNC;
}({});
export let ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC = /*#__PURE__*/function (ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC) {
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["_id"] = "_id";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["logo"] = "logo";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["logoBranded"] = "logoBranded";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["name"] = "name";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["categories"] = "categories";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["minQuant"] = "minQuant";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["quantities"] = "quantities";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["price"] = "price";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["categoryPrice"] = "categoryPrice";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["variants"] = "variants";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["designUploadMode"] = "designUploadMode";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["maxPrintColors"] = "maxPrintColors";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["seoSlug"] = "seoSlug";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["hidden"] = "hidden";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["productLabel"] = "productLabel";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["forbiddenForInventory"] = "forbiddenForInventory";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["forbiddenForBox"] = "forbiddenForBox";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["descriptionForWarehouse"] = "descriptionForWarehouse";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["tenantVisibility"] = "tenantVisibility";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["limitedEdition"] = "limitedEdition";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["spaceMargin"] = "spaceMargin";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["margin"] = "margin";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["hasSize"] = "hasSize";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["isAlwaysInStock"] = "isAlwaysInStock";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["outOfStockThreshold"] = "outOfStockThreshold";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["tags"] = "tags";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["createdAt"] = "createdAt";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["logoUploadBlankOption"] = "logoUploadBlankOption";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["publicId"] = "publicId";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["num"] = "num";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["resellerMarginReduction"] = "resellerMarginReduction";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["specialProductType"] = "specialProductType";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["priceTags"] = "priceTags";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["type"] = "type";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["basePrice"] = "basePrice";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["printRunPrices"] = "printRunPrices";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["searchableOnly"] = "searchableOnly";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["printRunMorePrice"] = "printRunMorePrice";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["linkOnly"] = "linkOnly";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["attributeValueIds"] = "attributeValueIds";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["supplier"] = "supplier";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["popularityIndex"] = "popularityIndex";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["accumulatorIds"] = "accumulatorIds";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["sortingParams"] = "sortingParams";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["childProductIds"] = "childProductIds";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["image"] = "image";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["link"] = "link";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["title"] = "title";
  ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC["mockupItem"] = "mockupItem";
  return ALLOWED_CURATED_BRAND_STORE_PRODUCT_FIELDS_TO_SYNC;
}({});
export const BLANK_EMBELLISHMENT_METHOD_NAME = 'blank';
export const DEFAULT_EMBELLISHMENT_NAME = 'default';
export const FULL_DESIGN_EMBELLISHMENT_NAME = 'fully custom';
export let FILTER_NAMES = /*#__PURE__*/function (FILTER_NAMES) {
  FILTER_NAMES["CATEGORY"] = "categoryId";
  FILTER_NAMES["PRICE_RANGE"] = "price range";
  FILTER_NAMES["MINIMUM_QUANTITY"] = "minimum quantity";
  FILTER_NAMES["COLOR"] = "colorFamily";
  FILTER_NAMES["PRODUCTION_TIME"] = "production time";
  FILTER_NAMES["BRAND"] = "brand";
  FILTER_NAMES["FEATURES"] = "features";
  FILTER_NAMES["BOX_AND_INVENTORY"] = "boxAndInventory";
  FILTER_NAMES["SUSTAINABILITY"] = "sustainability";
  FILTER_NAMES["LOCATIONS_TO_PRINT"] = "imprintLocationsAmount";
  FILTER_NAMES["FIT"] = "fit";
  FILTER_NAMES["EXTENDED_SIZES"] = "extended sizes";
  FILTER_NAMES["MATERIAL"] = "material";
  FILTER_NAMES["HAT_TYPE"] = "hat type";
  FILTER_NAMES["SLEEVE_LENGTH"] = "sleeve length";
  FILTER_NAMES["DECORATION_METHOD"] = "embellishmentMethod";
  FILTER_NAMES["INK_COLOR"] = "ink color";
  FILTER_NAMES["DESIGN_COLOR_LIMIT"] = "maxPrintColors";
  FILTER_NAMES["DRINKWARE_CAPACITY"] = "drinkware capacity";
  FILTER_NAMES["LID_STYLE"] = "lid style";
  FILTER_NAMES["OZ"] = "oz";
  FILTER_NAMES["BATTERY_CAPACITY_MAH"] = "battery capacity mah";
  FILTER_NAMES["LAPTOP_SIZE"] = "laptop size";
  FILTER_NAMES["MEMORY"] = "memory";
  FILTER_NAMES["PET_ACCESSORIES"] = "pet accessories";
  FILTER_NAMES["BOOK_THEME"] = "book library";
  FILTER_NAMES["NOTEBOOK_SIZE"] = "notebook size";
  FILTER_NAMES["CANDY_FLAVORS"] = "candy flavors";
  FILTER_NAMES["FOOD"] = "food";
  FILTER_NAMES["TOTE_LARGEST_DIMENSION"] = "tote largest dimension";
  FILTER_NAMES["UMBRELLAS"] = "umbrellas";
  FILTER_NAMES["LANYARD_LENGTH"] = "lanyard length";
  FILTER_NAMES["LANYARD_WIDTH"] = "lanyard width";
  FILTER_NAMES["INTERATIONAL_SHIPPING"] = "internationalShipping";
  return FILTER_NAMES;
}({});
export const FILTERS_ORDER = {
  [FILTER_NAMES.CATEGORY]: 0,
  [FILTER_NAMES.PRICE_RANGE]: 1,
  [FILTER_NAMES.MINIMUM_QUANTITY]: 2,
  [FILTER_NAMES.COLOR]: 3,
  [FILTER_NAMES.PRODUCTION_TIME]: 4,
  [FILTER_NAMES.INTERATIONAL_SHIPPING]: 5,
  [FILTER_NAMES.BRAND]: 6,
  [FILTER_NAMES.FEATURES]: 7,
  [FILTER_NAMES.BOX_AND_INVENTORY]: 8,
  [FILTER_NAMES.SUSTAINABILITY]: 9,
  [FILTER_NAMES.LOCATIONS_TO_PRINT]: 10,
  [FILTER_NAMES.FIT]: 11,
  [FILTER_NAMES.EXTENDED_SIZES]: 12,
  [FILTER_NAMES.MATERIAL]: 13,
  [FILTER_NAMES.HAT_TYPE]: 14,
  [FILTER_NAMES.SLEEVE_LENGTH]: 15,
  [FILTER_NAMES.DECORATION_METHOD]: 16,
  [FILTER_NAMES.INK_COLOR]: 17,
  [FILTER_NAMES.DESIGN_COLOR_LIMIT]: 18,
  [FILTER_NAMES.DRINKWARE_CAPACITY]: 19,
  [FILTER_NAMES.LID_STYLE]: 20,
  [FILTER_NAMES.OZ]: 21,
  [FILTER_NAMES.BATTERY_CAPACITY_MAH]: 22,
  [FILTER_NAMES.LAPTOP_SIZE]: 23,
  [FILTER_NAMES.MEMORY]: 24,
  [FILTER_NAMES.PET_ACCESSORIES]: 25,
  [FILTER_NAMES.BOOK_THEME]: 26,
  [FILTER_NAMES.NOTEBOOK_SIZE]: 27,
  [FILTER_NAMES.CANDY_FLAVORS]: 28,
  [FILTER_NAMES.FOOD]: 29,
  [FILTER_NAMES.TOTE_LARGEST_DIMENSION]: 30,
  [FILTER_NAMES.UMBRELLAS]: 31,
  [FILTER_NAMES.LANYARD_LENGTH]: 32,
  [FILTER_NAMES.LANYARD_WIDTH]: 33
};
export const FILTER_ITEMS_ORDER = {
  [FILTER_NAMES.DRINKWARE_CAPACITY]: {
    '37 Oz. or More': 0,
    '32-36 Oz.': 1,
    '27-31 Oz.': 2,
    '20-26 Oz.': 3,
    '15-19 Oz.': 4,
    '6-14 Oz.': 5,
    '1-5 Oz.': 6
  },
  [FILTER_NAMES.FIT]: {
    "Men's": 1,
    "Women's": 2,
    Unisex: 3,
    'Baby & Toddler': 4,
    Youth: 5,
    Pants: 6,
    Shorts: 7
  },
  [FILTER_NAMES.DECORATION_METHOD]: {
    screenprint: 0,
    embroidery: 1,
    'digital print': 2
  },
  [FILTER_NAMES.OZ]: {
    '16-20 Oz.': 0,
    '11-15 Oz.': 1,
    '6-10 Oz.': 2,
    '3 Oz.': 3,
    '2 Oz.': 4,
    '1.5 Oz.': 5,
    '1 Oz.': 6,
    'Less Than 1 Oz.': 7
  },
  [FILTER_NAMES.SUSTAINABILITY]: {
    'Eco-Friendly': 0,
    'B. Corporation': 1,
    'Carbon Neutral': 2,
    '1% to the Planet': 3,
    'Giveback Programs': 4
  },
  [FILTER_NAMES.BATTERY_CAPACITY_MAH]: {
    '20,000 mAh+': 0,
    '10,000-19,000 mAh': 1,
    '6,000-9,000 mAh': 2,
    '3,000-5,900 mAh': 3,
    '2,000-2,900 mAh': 4,
    'under 1,000 mAh': 5
  },
  [FILTER_NAMES.MEMORY]: {
    '32GB': 0,
    '16GB': 1,
    '8GB': 2,
    '4GB': 3,
    '2GB': 4
  },
  [FILTER_NAMES.COLOR]: {
    black: 0,
    white: 1,
    blue: 2,
    red: 3,
    gray: 4,
    silver: 5,
    green: 6,
    orange: 7,
    purple: 8,
    yellow: 9,
    brown: 10,
    pink: 11
  }
};
export const FILTER_CUSTOM_NAMES = {
  [FILTER_NAMES.UMBRELLAS]: 'Umbrella Type',
  [FILTER_NAMES.DECORATION_METHOD]: 'Decoration method',
  [FILTER_NAMES.LID_STYLE]: 'Drinkware Lid Style',
  [FILTER_NAMES.BATTERY_CAPACITY_MAH]: 'Battery Capacity MAh'
};
export const NON_DATA_IS_ATTRIBUTE_FILTERS = [FILTER_NAMES.BOX_AND_INVENTORY, FILTER_NAMES.DESIGN_COLOR_LIMIT, FILTER_NAMES.LOCATIONS_TO_PRINT, FILTER_NAMES.DECORATION_METHOD, FILTER_NAMES.INTERATIONAL_SHIPPING];
export const HIDDEN_FOR_CURATED_BRAND_STORE = [FILTER_NAMES.LOCATIONS_TO_PRINT, FILTER_NAMES.DESIGN_COLOR_LIMIT];
export const NON_DATA_IS_ATTRIBUTE_FILTERS_FOR_CURATED_BRAND_STORE = [FILTER_NAMES.DECORATION_METHOD];
export const DEFAULT_MINIMUM_COLORS_NUMBER = 1;